export default __webpack_public_path__ + "static/media/footer-phone.528a6889.svg";